import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  client: null,
};

const twilioSlice = createSlice({
  name: "twilioSlice",
  initialState,
  reducers: {
    setTwilioClient: (state, { payload }) => {
      state.client = payload;
    },
    clearTwilioSlice: (state) => {
      state.client = null;
    },
  },
});

export const { setTwilioClient, clearTwilioSlice } = twilioSlice.actions;
export const twilioReducer = twilioSlice.reducer;
